import { h } from "@stencil/core";
import pfx from "../../utils/style-class-prefix-helper";

// the props in this are (factory) functions instead of attributes because it's not recommended to reuse JSX elements in Stencil
// see https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes
export const buttonSvgs = {
  primary: {
    text: {
      normal: {
        cornerLeftTop: () => (
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              d="M24,48c-4.5,0-12.9-0.3-16.2-1c-3.4-0.7-5.5-2.8-6.2-6.2S0,30.6,0,24S0.8,10.5,1.5,7.2S4.4,1.6,7.8,1 S19.5,0,24,0V48z"
            />
          </svg>
        ),
        cornerLeftBottom: () => (
          <svg width="24" height="24" viewBox="0 24 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              d="M24,48c-4.5,0-12.9-0.3-16.2-1c-3.4-0.7-5.5-2.8-6.2-6.2S0,30.6,0,24S0.8,10.5,1.5,7.2S4.4,1.6,7.8,1 S19.5,0,24,0V48z"
            />
          </svg>
        ),
        cornerRightTop: () => (
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              transform="rotate(180 12 24)"
              d="M24,48c-4.5,0-12.9-0.3-16.2-1c-3.4-0.7-5.5-2.8-6.2-6.2S0,30.6,0,24S0.8,10.5,1.5,7.2S4.4,1.6,7.8,1 S19.5,0,24,0V48z"
            />
          </svg>
        ),
        cornerRightBottom: () => (
          <svg width="24" height="24" viewBox="0 24 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              transform="rotate(180 12 24)"
              d="M24,48c-4.5,0-12.9-0.3-16.2-1c-3.4-0.7-5.5-2.8-6.2-6.2S0,30.6,0,24S0.8,10.5,1.5,7.2S4.4,1.6,7.8,1 S19.5,0,24,0V48z"
            />
          </svg>
        )
      },
      small: {
        cornerLeftTop: () => (
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              d="M5.178.662a5.108 5.108 0 0 0-4.149 4.122 61.641 61.641 0 0 0 0 22.432 5.1 5.1 0 0 0 4.149 4.119c3.593.419 7.205.64 10.822.665V0A96.8 96.8 0 0 0 5.178.662z"
            />
          </svg>
        ),
        cornerLeftBottom: () => (
          <svg width="16" height="16" viewBox="0 16 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              d="M5.178.662a5.108 5.108 0 0 0-4.149 4.122 61.641 61.641 0 0 0 0 22.432 5.1 5.1 0 0 0 4.149 4.119c3.593.419 7.205.64 10.822.665V0A96.8 96.8 0 0 0 5.178.662z"
            />
          </svg>
        ),
        cornerRightTop: () => (
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              transform="rotate(180 8 16)"
              d="M5.178.662a5.108 5.108 0 0 0-4.149 4.122 61.641 61.641 0 0 0 0 22.432 5.1 5.1 0 0 0 4.149 4.119c3.593.419 7.205.64 10.822.665V0A96.8 96.8 0 0 0 5.178.662z"
            />
          </svg>
        ),
        cornerRightBottom: () => (
          <svg width="16" height="16" viewBox="0 16 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge solid")}
              transform="rotate(180 8 16)"
              d="M5.178.662a5.108 5.108 0 0 0-4.149 4.122 61.641 61.641 0 0 0 0 22.432 5.1 5.1 0 0 0 4.149 4.119c3.593.419 7.205.64 10.822.665V0A96.8 96.8 0 0 0 5.178.662z"
            />
          </svg>
        )
      }
    },
    icon: {
      large: () => (
        <svg width="96" height="96" viewBox="0 0 96 96" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <defs></defs>
          <path
            class={pfx("carrier solid")}
            d="M 15.536 3.088 C 9.222 4.286 4.286 9.222 3.088 15.535 C -1.03 36.982 -1.03 59.016 3.088 80.465 C 4.286 86.776 9.222 91.714 15.536 92.912 C 26.236 94.959 37.104 95.992 48 96 C 58.893 95.992 69.763 94.959 80.465 92.912 C 86.777 91.714 91.715 86.776 92.913 80.465 C 97.029 59.016 97.029 36.982 92.913 15.535 C 91.715 9.222 86.777 4.286 80.465 3.088 C 59.017 -1.029 36.982 -1.029 15.536 3.088 Z"
          ></path>
        </svg>
      ),
      normal: () => (
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            class={pfx("carrier solid")}
            d="M7.768 1.544a7.818 7.818 0 0 0-6.224 6.224 86.081 86.081 0 0 0 0 32.464 7.818 7.818 0 0 0 6.224 6.224A86.694 86.694 0 0 0 24 48a86.694 86.694 0 0 0 16.232-1.544 7.818 7.818 0 0 0 6.224-6.224 86.081 86.081 0 0 0 0-32.464 7.818 7.818 0 0 0-6.224-6.224 86.1 86.1 0 0 0-32.464 0z"
          />
        </svg>
      ),
      small: () => (
        <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            class={pfx("carrier solid")}
            d="M5.8,1.2C3.5,1.6,1.6,3.5,1.2,5.8c-1.5,8-1.5,16.3,0,24.3c0.5,2.4,2.3,4.2,4.7,4.7c4,0.8,8.1,1.2,12.2,1.2c4.1,0,8.2-0.4,12.2-1.2c2.4-0.5,4.2-2.3,4.7-4.7c1.5-8,1.5-16.3,0-24.3c-0.5-2.4-2.3-4.2-4.7-4.7C22.1-0.4,13.9-0.4,5.8,1.2z"
          />
        </svg>
      )
    }
  },
  secondary: {
    text: {
      normal: {
        cornerLeftTop: () => (
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              d="M24 1c-6.3 0-13.1.45-16.05 1C5 2.55 3.2 4.5 2.55 7.4 1.9 10.3 1 16 1 24c0 8 .9 13.75 1.55 16.65C3.2 43.55 5 45.5 7.95 46S17.7 47 24 47"
            />
          </svg>
        ),
        cornerLeftBottom: () => (
          <svg width="24" height="24" viewBox="0 24 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              d="M24 1c-6.3 0-13.1.45-16.05 1C5 2.55 3.2 4.5 2.55 7.4 1.9 10.3 1 16 1 24c0 8 .9 13.75 1.55 16.65C3.2 43.55 5 45.5 7.95 46S17.7 47 24 47"
            />
          </svg>
        ),
        cornerRightTop: () => (
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              transform="rotate(180 12 24)"
              d="M24 1c-6.3 0-13.1.45-16.05 1C5 2.55 3.2 4.5 2.55 7.4 1.9 10.3 1 16 1 24c0 8 .9 13.75 1.55 16.65C3.2 43.55 5 45.5 7.95 46S17.7 47 24 47"
            />
          </svg>
        ),
        cornerRightBottom: () => (
          <svg width="24" height="24" viewBox="0 24 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              transform="rotate(180 12 24)"
              d="M24 1c-6.3 0-13.1.45-16.05 1C5 2.55 3.2 4.5 2.55 7.4 1.9 10.3 1 16 1 24c0 8 .9 13.75 1.55 16.65C3.2 43.55 5 45.5 7.95 46S17.7 47 24 47"
            />
          </svg>
        )
      },
      small: {
        cornerLeftTop: () => (
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              d="M16 1.004a72.52 72.52 0 0 0-10.467.652 4.259 4.259 0 0 0-3.522 3.522A51.286 51.286 0 0 0 1 16.004a51.685 51.685 0 0 0 1.011 10.859 4.186 4.186 0 0 0 3.522 3.489c3.47.453 6.967.67 10.467.652"
            />
          </svg>
        ),
        cornerLeftBottom: () => (
          <svg width="16" height="16" viewBox="0 16 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              d="M16 1.004a72.52 72.52 0 0 0-10.467.652 4.259 4.259 0 0 0-3.522 3.522A51.286 51.286 0 0 0 1 16.004a51.685 51.685 0 0 0 1.011 10.859 4.186 4.186 0 0 0 3.522 3.489c3.47.453 6.967.67 10.467.652"
            />
          </svg>
        ),
        cornerRightTop: () => (
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              transform="rotate(180 8 16)"
              d="M16 1.004a72.52 72.52 0 0 0-10.467.652 4.259 4.259 0 0 0-3.522 3.522A51.286 51.286 0 0 0 1 16.004a51.685 51.685 0 0 0 1.011 10.859 4.186 4.186 0 0 0 3.522 3.489c3.47.453 6.967.67 10.467.652"
            />
          </svg>
        ),
        cornerRightBottom: () => (
          <svg width="16" height="16" viewBox="0 16 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              class={pfx("edge outline")}
              transform="rotate(180 8 16)"
              d="M16 1.004a72.52 72.52 0 0 0-10.467.652 4.259 4.259 0 0 0-3.522 3.522A51.286 51.286 0 0 0 1 16.004a51.685 51.685 0 0 0 1.011 10.859 4.186 4.186 0 0 0 3.522 3.489c3.47.453 6.967.67 10.467.652"
            />
          </svg>
        )
      }
    },
    icon: {
      normal: () => (
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            class={pfx("carrier outline")}
            d="M24 47a89.9 89.9 0 0 0 16-1.5 6.677 6.677 0 0 0 5.5-5.5A95.681 95.681 0 0 0 47 24a89.9 89.9 0 0 0-1.5-16A6.677 6.677 0 0 0 40 2.5 95.681 95.681 0 0 0 24 1 89.9 89.9 0 0 0 8 2.5 6.677 6.677 0 0 0 2.5 8 95.681 95.681 0 0 0 1 24a89.9 89.9 0 0 0 1.5 16A6.677 6.677 0 0 0 8 45.5 95.681 95.681 0 0 0 24 47z"
          />
        </svg>
      ),
      small: () => (
        <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            class={pfx("carrier outline")}
            d="M18,35c4,0,7.9-0.4,11.8-1.1c2.1-0.3,3.7-2,4.1-4.1C34.6,25.9,35,22,35,18c0-4-0.4-7.9-1.1-11.8c-0.3-2.1-2-3.7-4.1-4.1C25.9,1.4,22,1,18,1c-4,0-7.9,0.4-11.8,1.1c-2.1,0.3-3.7,2-4.1,4.1C1.4,10.1,1,14,1,18c0,4,0.4,7.9,1.1,11.8c0.3,2.1,2,3.7,4.1,4.1C10.1,34.6,14,35,18,35z"
          />
        </svg>
      )
    }
  }
};
